import '../../../plugins/citeProc/js/citeproc.min.js';
import { BaseService, BaseInjector } from '../../node_modules/ui-theme/js/base';
import EurekaExportCitation, {
    ExportCitationElements,
    ExportCitationSelectors,
    ExportCitationClassList,
    ExportCitationTexts,
} from '../../node_modules/ui-theme/widgets/export-citations/index'; 
interface ExportCitation extends BaseService<ExportCitationSelectors, ExportCitationElements, ExportCitationClassList, ExportCitationTexts> { }

@BaseInjector(ExportCitationSelectors, ExportCitationElements, ExportCitationClassList, ExportCitationTexts)
class ExportCitation extends EurekaExportCitation {
    async performServerSideAjax(url: string, params : any, selectCiteStyle: string) {
        const queryString = new URLSearchParams(params).toString();
        const requestUrl = `${url}?${queryString}`;
      
        try {
          const response = await fetch(requestUrl);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          let itemIDs = [];
                let citeproc;
                let result;
                const responseData = await response.json();
                this.response = responseData;
                
                this.response.items.forEach(function (item, i) {
                    for (let key in item) {
                        itemIDs.push(key);
                    }
                });

                this.responseFormat[selectCiteStyle] = this.response;
                let citeprocSys = {
                    retrieveLocale: (lang) => {                        
                        return this.response.locale;
                    },
                    retrieveItem: (key) => {
                        var index = itemIDs.indexOf(key);
                        return this.response.items[index][key];
                    },
                };

                citeproc = new (window as any).CSL.Engine(citeprocSys, this.response.style);
                citeproc.opt.development_extensions.wrap_url_and_doi = false;
                citeproc.opt.development_extensions.field_hack = false;
                citeproc.opt.mode = 'text';
                citeproc.updateItems(itemIDs);
                result = citeproc.makeBibliography();
                this.responseFormat[selectCiteStyle].content = result[1];
                this.setContent(this.responseFormat[selectCiteStyle].content);
                this.downloadCiteProc();
        } catch (error) {
          console.error('There has been a problem with your fetch operation:', error);
        }
    }
    //remove after LIT-587719 is merged
    loadCiteProc(elem : HTMLSelectElement ): void {
        this.selectCiteStyle = elem.value;
        const selectedFormat  = ( document.querySelector('option[value="' + this.selectCiteStyle + '"]') as HTMLElement ).dataset.format;
        const targetCustomCSLFIle = 'custom-' + this.selectCiteStyle;
        this.elements.warningMessage.innerHTML = '';

        if (this.selectCiteStyle) {
            this.elements.cslWrapper.querySelectorAll('.copy__btn, .download__btn').forEach(function (element : HTMLAnchorElement) {
                element.classList.add('disabled');
            });

            this.elements.exportCitationSelect.disabled = true;

            const loadingText = 'Loading ' + this.loadingAdditionalInfo + '... ';
            this.elements.cslResponse.innerHTML = '<span>' + loadingText + '</span>';

            const action_server = '/action/exportCiteProcCitation';
            // const action_server = '/specs/libraries/ui-theme-eureka/widgets/export-citations/dummy-csl-metaData-one-citation.json'; // dummy for UX3 testing
            // const action_server = '/specs/libraries/ui-theme-eureka/widgets/export-citations/dummy-csl-metaData-multi-citation.json'; // dummy for UX3 testing
            const params = this.setParams(targetCustomCSLFIle, selectedFormat);

            if (typeof this.responseFormat[this.selectCiteStyle] !== 'undefined') {
                this.setContent(this.responseFormat[this.selectCiteStyle].content);
                this.downloadCiteProc();
            } else {
                this.performServerSideAjax(action_server, params, this.selectCiteStyle);
            }

            (this.elements.cslWrapper.querySelector('[name="dois"]') as HTMLInputElement ).value = this.dois;
            (this.elements.cslWrapper.querySelector('[name="format"]') as HTMLInputElement ).value = selectedFormat;
        }   
    }
}

export default ExportCitation;

export {
    ExportCitationElements,
    ExportCitationSelectors,
    ExportCitationClassList,
    ExportCitationTexts
}
